import { defineComponent as L, computed as V, ref as y, createElementBlock as C, openBlock as f, createElementVNode as l, createVNode as s, unref as e, withCtx as a, toDisplayString as D, Fragment as I, renderList as O, createBlock as S, withModifiers as v, createCommentVNode as U } from "vue";
import { useModal as $, ScalarDropdown as N, ScalarButton as z, ScalarDropdownItem as h, ScalarListboxCheckbox as q, ScalarIcon as k, ScalarDropdownDivider as F, ScalarModal as E } from "@scalar/components";
import { useRouter as P } from "vue-router";
import Y from "../../../components/Sidebar/Actions/DeleteSidebarListElement.vue.js";
import G from "../../../components/Sidebar/Actions/EditSidebarListElement.vue.js";
import { useActiveEntities as H } from "../../../store/active-entities.js";
import { useWorkspace as J } from "../../../store/store.js";
const K = { class: "flex w-[inherit] items-center text-base" }, Q = { class: "m-0 flex items-center gap-1.5 font-bold" }, X = { class: "line-clamp-1 text-left" }, Z = { class: "overflow-hidden text-ellipsis" }, ee = { class: "flex h-4 w-4 items-center justify-center" }, ce = /* @__PURE__ */ L({
  __name: "WorkspaceDropdown",
  setup(te) {
    const { activeWorkspace: c } = H(), { workspaces: r, workspaceMutators: x, events: T } = J(), { push: g } = P(), j = (o) => {
      var t;
      o !== ((t = c.value) == null ? void 0 : t.uid) && g({
        name: "workspace",
        params: {
          workspace: o
        }
      });
    }, b = V(() => Object.keys(r).length === 1), B = () => T.commandPalette.emit({ commandName: "Create Workspace" }), d = y(""), i = y(""), u = $(), p = $(), W = (o) => {
      const t = r[o];
      t && (d.value = t.name, i.value = o, u.show());
    }, R = (o) => {
      o.trim() && (x.edit(i.value, "name", o.trim()), u.hide());
    }, M = (o) => {
      const t = r[o];
      t && (d.value = t.name, i.value = o, p.show());
    }, A = async () => {
      var o;
      if (!b.value) {
        const t = ((o = c.value) == null ? void 0 : o.uid) === i.value, n = { ...r };
        if (delete n[i.value], x.delete(i.value), t) {
          const m = Object.keys(n)[0];
          await g({
            name: "workspace",
            params: {
              workspace: m
            }
          });
        }
      }
      p.hide();
    };
    return (o, t) => (f(), C("div", null, [
      l("div", K, [
        s(e(N), null, {
          items: a(() => [
            (f(!0), C(I, null, O(e(r), (n, m) => (f(), S(e(h), {
              key: m,
              class: "group/item flex w-full items-center gap-1.5 overflow-hidden text-ellipsis whitespace-nowrap",
              onClick: v((w) => j(n.uid), ["stop"])
            }, {
              default: a(() => {
                var w;
                return [
                  s(e(q), {
                    selected: ((w = e(c)) == null ? void 0 : w.uid) === m
                  }, null, 8, ["selected"]),
                  l("span", Z, D(n.name), 1),
                  s(e(N), {
                    placement: "right-start",
                    teleport: ""
                  }, {
                    items: a(() => [
                      s(e(h), {
                        class: "flex gap-2",
                        onMousedown: (_) => W(n.uid),
                        onTouchend: v((_) => W(n.uid), ["prevent"])
                      }, {
                        default: a(() => [
                          s(e(k), {
                            class: "inline-flex",
                            icon: "Edit",
                            size: "md",
                            thickness: "1.5"
                          }),
                          t[2] || (t[2] = l("span", null, "Rename", -1))
                        ]),
                        _: 2,
                        __: [2]
                      }, 1032, ["onMousedown", "onTouchend"]),
                      b.value ? U("", !0) : (f(), S(e(h), {
                        key: 0,
                        class: "flex gap-2",
                        onMousedown: v((_) => M(n.uid), ["prevent"]),
                        onTouchend: v((_) => M(n.uid), ["prevent"])
                      }, {
                        default: a(() => [
                          s(e(k), {
                            class: "inline-flex",
                            icon: "Delete",
                            size: "md",
                            thickness: "1.5"
                          }),
                          t[3] || (t[3] = l("span", null, "Delete", -1))
                        ]),
                        _: 2,
                        __: [3]
                      }, 1032, ["onMousedown", "onTouchend"]))
                    ]),
                    default: a(() => [
                      s(e(z), {
                        class: "hover:bg-b-3 -mr-1 ml-auto aspect-square h-fit px-0.5 py-0 group-hover/item:flex",
                        size: "sm",
                        type: "button",
                        variant: "ghost"
                      }, {
                        default: a(() => [
                          s(e(k), {
                            icon: "Ellipses",
                            size: "sm"
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 2
                  }, 1024)
                ];
              }),
              _: 2
            }, 1032, ["onClick"]))), 128)),
            s(e(F)),
            s(e(h), {
              class: "flex items-center gap-1.5",
              onClick: B
            }, {
              default: a(() => [
                l("div", ee, [
                  s(e(k), {
                    icon: "Add",
                    size: "sm"
                  })
                ]),
                t[4] || (t[4] = l("span", null, "Create Workspace", -1))
              ]),
              _: 1,
              __: [4]
            })
          ]),
          default: a(() => [
            s(e(z), {
              class: "text-c-1 hover:bg-b-2 line-clamp-1 h-full w-fit justify-start px-1.5 py-1.5 font-normal",
              fullWidth: "",
              variant: "ghost"
            }, {
              default: a(() => {
                var n;
                return [
                  l("div", Q, [
                    l("h2", X, D((n = e(c)) == null ? void 0 : n.name), 1)
                  ])
                ];
              }),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      s(e(E), {
        size: "xxs",
        state: e(p),
        title: "Delete workspace"
      }, {
        default: a(() => [
          s(Y, {
            variableName: d.value,
            warningMessage: "This cannot be undone. You're about to delete the workspace and everything inside it.",
            onClose: t[0] || (t[0] = (n) => e(p).hide()),
            onDelete: A
          }, null, 8, ["variableName"])
        ]),
        _: 1
      }, 8, ["state"]),
      s(e(E), {
        size: "xxs",
        state: e(u),
        title: "Rename Workspace"
      }, {
        default: a(() => [
          s(G, {
            name: d.value,
            onClose: t[1] || (t[1] = (n) => e(u).hide()),
            onEdit: R
          }, null, 8, ["name"])
        ]),
        _: 1
      }, 8, ["state"])
    ]));
  }
});
export {
  ce as default
};
